export function getDisplaySetImageIds(
  displaySetInstanceUID: string,
  servicesManager: AppTypes.ServicesManager,
  extensionManager: AppTypes.ExtensionManager
): string[] {
  const { displaySetService } = servicesManager.services;
  const [dataSource] = extensionManager.getActiveDataSource();
  const displaySet = displaySetService.getDisplaySetByUID(displaySetInstanceUID);

  if (!displaySet || !dataSource?.getImageIdsForDisplaySet) {
    return [];
  }

  return (dataSource.getImageIdsForDisplaySet(displaySet) || []).filter(Boolean);
}

export function getCurrentViewportImageId(
  viewportId: string,
  servicesManager: AppTypes.ServicesManager
): string | null {
  const { cornerstoneViewportService } = servicesManager.services;
  const viewport = cornerstoneViewportService.getCornerstoneViewport(viewportId) as {
    getCurrentImageId?: () => string | undefined;
  } | null;

  return viewport?.getCurrentImageId?.() ?? null;
}
